var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.18389 1.93733C9.89871 0.387586 12.1013 0.387586 12.8161 1.93733L14.481 5.54682C14.7723 6.17844 15.3709 6.61332 16.0616 6.69522L20.009 7.16324C21.7037 7.36418 22.3844 9.45895 21.1314 10.6177L18.213 13.3165C17.7024 13.7888 17.4737 14.4924 17.6093 15.1746L18.384 19.0734C18.7166 20.7473 16.9346 22.042 15.4454 21.2084L11.9769 19.2668C11.3699 18.9271 10.6301 18.9271 10.0231 19.2668L6.55458 21.2084C5.06535 22.042 3.28343 20.7473 3.61604 19.0734L4.39072 15.1746C4.52628 14.4924 4.29764 13.7888 3.78697 13.3165L0.868622 10.6177C-0.384378 9.45895 0.296254 7.36418 1.99104 7.16324L5.93836 6.69522C6.62908 6.61332 7.22765 6.17844 7.51899 5.54682L9.18389 1.93733Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.cc18f1a0.svg";
export { ForwardRef as ReactComponent };